import axios from "axios";
import { BASEURL } from "../../baseUrl";
import { toast } from "react-toastify";
// Action Types
export const ADD_EXTRA_ADMIN = 'ADD_EXTRA_ADMIN';
export const UPDATE_EXTRA_ADMIN = 'UPDATE_EXTRA_ADMIN';
export const DELETE_EXTRA_ADMIN = 'DELETE_EXTRA_ADMIN';
export const GET_EXTRA_ADMIN = 'GET_EXTRA_ADMIN';
export const GET_ALL_EXTRA_ADMIN = 'GET_ALL_EXTRA_ADMIN';

// Action Creators
const addExtraAdminAction = (payload) => ({ type: ADD_EXTRA_ADMIN, payload });
const updateExtraAdminAction = (payload) => ({ type: UPDATE_EXTRA_ADMIN, payload });
const deleteExtraAdminAction = (payload) => ({ type: DELETE_EXTRA_ADMIN, payload });
const getExtraAdminAction = (payload) => ({ type: GET_EXTRA_ADMIN, payload });
const getAllExtraAdminAction = (payload) => ({ type: GET_ALL_EXTRA_ADMIN, payload });

// Action Functions
export const addExtraAdmin = (data) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.post(`${BASEURL}/subAdmin/add-extra-admin`, data, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).then((res) => {
                if (res?.data?.success) {
                    toast.success(res.data.message);
                }
                dispatch(addExtraAdminAction(res));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                dispatch(addExtraAdminAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log('Error adding extra admin:', error);
        }
    };
};

export const updateExtraAdmin = (id, data) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.put(`${BASEURL}/subAdmin/update-extra-admin/${id}`, data, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).then((res) => {
                if (res?.data?.success) {
                    toast.success(res.data.message);
                }
                dispatch(updateExtraAdminAction(res));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                dispatch(updateExtraAdminAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log('Error updating extra admin:', error);
        }
    };
};

export const deleteExtraAdmin = (id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${BASEURL}/subAdmin/delete-extra-admin/${id}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).then((res) => {
                if (res?.data?.success) {
                    toast.success(res.data.message);
                }
                dispatch(deleteExtraAdminAction(res));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                dispatch(deleteExtraAdminAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log('Error deleting extra admin:', error);
        }
    };
};

export const getExtraAdmin = (id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.get(`${BASEURL}/subAdmin/get-extra-admin/${id}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).then((res) => {
                dispatch(getExtraAdminAction(res));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                dispatch(getExtraAdminAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log('Error getting extra admin:', error);
        }
    };
};

export const getAllExtraAdmin = () => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.get(`${BASEURL}/subAdmin/get-all-extra-admin`, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).then((res) => {
                dispatch(getAllExtraAdminAction(res));
            }).catch((error) => {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                dispatch(getAllExtraAdminAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Something went wrong');
            console.log('Error getting all extra admins:', error);
        }
    };
};